export default __webpack_public_path__ + "static/updownsmall-14a4a98c5b8eca6c32f36ab025436adf.png";